import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const PropertyList = (props) => {
  const { items, className } = props;
  const componentBaseClass = "sal-property-list";
  const componentClass = classnames(componentBaseClass, className);
  const itemMarkup = items.map((item, index) => {
    return (
      <div key={index} className={componentBaseClass + "__item"}>
        <dt className={componentBaseClass + "__term"}>{item.name}</dt>
        <dd className={componentBaseClass + "__desc"}>{item.value}</dd>
      </div>
    );
  });

  return <dl className={componentClass}>{itemMarkup}</dl>;
};

PropertyList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export default PropertyList;
